

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

// @ is an alias to /src
import LoginForm from "@/components/Auth/LoginForm.vue";

import NavBar from "@/components/Layout/NavBar.vue";
import AsideMenu from "@/components/Layout/AsideMenu.vue";
import { ServerResult } from "./core/http/server_result";
// import FooterBar from '@/components/Layout/FooterBar.vue'

// import { mdiTruckDeliveryOutline } from '@mdi/js';

@Component({
  computed: {
    ...mapState("ubic", ["token", "actor"]),
    ...mapGetters("ubic", ["isAuthenticated"]),
  },
  components: {
    LoginForm,
    AsideMenu,
    NavBar,
  },
})
export default class App extends Vue {
  public isAuthenticated!: boolean;
  public actor!: any;

  get menu() {
    const _menu: any = [
      "Склады",
      [
        {
          to: { name: "warehouses-internal-list" },
          label: "Склады полупродукта",
          icon: "store-outline",
          permissions: ["admin", "sales_head"],
        },
        {
          to: { name: "warehouses-unfinished-list" },
          label: "Склад незавершенной продукции",
          icon: "store",
          permissions: ["admin", "sales_head"],
        },
        {
          to: { name: "warehouses-utilization-list" },
          label: "Склад утилизации",
          icon: "store-remove",
          permissions: ["admin", "sales_head"],
        },
        {
          to: { name: "warehouses-carantine-list" },
          label: "Склад карантина",
          icon: "storefront",
          permissions: ["admin", "sales_head"],
        },
        {
          to: { name: "warehouses-recycling-list" },
          label: "Склад переработки",
          icon: "store-24-hour",
          permissions: ["admin", "sales_head"],
        },
        {
          to: { name: "warehouses-done-list" },
          label: "Склад готовой продукции",
          icon: "store-plus",
          permissions: ["admin", "sales_head"],
        },
      ],
      "Продукты",
      [
        {
          to: { name: "produced-product" },
          label: "Продукты производства",
          icon: "cookie-plus-outline",
          // permissions: ['admin'],
        },
        {
          label: "Сырье",
          icon: "nutrition",
          submenu: "ingredients",
          permissions: ["admin"],
          props: [
            [
              {
                to: { name: "ingredients-manager" },
                label: "Список сырья",
                icon: "nutrition",
                permissions: ["admin"],
              },
              {
                to: { name: "batches-manager" },
                label: "Партии сырья",
                icon: "table",
                permissions: ["admin"],
              },
            ],
          ],
        },
        {
          to: { name: "bases-list" },
          label: "Рецептуры",
          icon: "table-of-contents",
          permissions: ["admin"],
        },
        {
          label: "Cловари",
          icon: "format-list-numbered",
          submenu: "ing-vocabularies",
          permissions: ["admin"],
          props: [
            [
              "В",
              {
                to: { name: "raw-materials-manager" },
                label: "Виды сырья",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "П",
              {
                to: { name: "subgroups-manager" },
                label: "Подгруппы",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "providers-manager" },
                label: "Поставщики",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "manufacturers-manager" },
                label: "Производители сырья",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
            ],
          ],
        },
      ],
      "Производство",
      [
        {
          to: { name: "shifts" },
          label: "Смены",
          icon: "pot-steam-outline",
          permissions: ["admin", "logistics_manager", "production"],
        },
        {
          to: { name: "lines-manager" },
          label: "Линии",
          icon: "coffee-to-go",
          permissions: ["admin"],
        },
        {
          to: { name: "equipment-manager" },
          label: "Оборудование",
          icon: "tools",
          permissions: ["admin"],
        },
        {
          to: { name: "volume-manager" },
          label: "Емкость для сквашивания",
          icon: "pail",
          permissions: ["admin"],
        },
        {
          to: { name: "watching-list" },
          label: "Мойки",
          icon: "dishwasher",
          permissions: ["admin"],
        },
        {
          to: { name: "calculator" },
          label: "Калькулятор",
          icon: "calculator",
          // permissions: ['admin'],
        },

        {
          label: "Cловари",
          icon: "format-list-numbered",
          submenu: "prod-vocabularies",
          permissions: ["admin"],
          props: [
            [
              "А",
              {
                to: { name: "activity-manager" },
                label: "Активность",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "Б",
              {
                to: { name: "glitter_thermomix-manager" },
                label: "Блеск в термомиксе	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "В",
              {
                to: { name: "release-gps-manager" },
                label: "Выпуск ГП",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "Г",
              {
                to: { name: "causticity-manager" },
                label: "Глубина колкости",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "densities-manager" },
                label: "Густота продукта во время варки",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "З",
              {
                to: { name: "work_orders-manager" },
                label: "Заказ-наряд",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "starter-types-manager" },
                label: "Закваски",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "sound_product_breaking-manager" },
                label: "Звук откола продукта лопаткой от общей массы	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "sound_product_released-manager" },
                label: "Звук при развозюкивании продукта	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "И",
              {
                to: { name: "incidents-manager" },
                label: "Инциденты",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "К",
              {
                to: { name: "quality-pps-manager" },
                label: "Качество ПП при загрузке",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "kislinka-manager" },
                label: "Кислинка	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "dry-caucity-manager" },
                label: "Количество сухой закваски",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "causticity_initial_spalling-manager" },
                label: "Колкость при первичном откалывании	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "consistensies-manager" },
                label: "Консистенция продукта на розливе",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "corrector-manager" },
                label: "Корректоры",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "Л",
              {
                to: { name: "logo-manager" },
                label: "Логотипы",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "М",
              {
                to: { name: "storages-manager" },
                label: "Места хранения",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "detergents-manager" },
                label: "Моющие средства",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "О",
              {
                to: { name: "feeling_of_texture-manager" },
                label: "Ощущение текстуры во рту	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "П",
              {
                to: { name: "plasticity-manager" },
                label: "Пластичность (эффект масличка)	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "looseness-manager" },
                label: "Плотность / Рыхлость	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "vices-manager" },
                label: "Пороки вкуса",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "providers-manager" },
                label: "Поставщики",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "reasons-manager" },
                label: "Причина закрытия",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "warehouse-transit-types" },
                label: "Причины перевода между складами",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "manufacturers-detergent-manager" },
                label: "Производители моющего средства",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "Р",
              {
                to: { name: "stirability_thermomix-manager" },
                label: "Размешиваемость в термомиксе	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "regulator-manager" },
                label: "Регуляторы",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "roles-manager" },
                label: "Роли в смене",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "rotates-manager" },
                label: "Ротации",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "С",
              {
                to: { name: "serbian_profile-manager" },
                label: "Сербский профиль	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "fluff_effect-manager" },
                label: 'Скорость растворения во рту (эффект "пух")',
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "sweetness-manager" },
                label: "Сладость	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "salinity-manager" },
                label: "Соленость	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "disposals-manager" },
                label: "Способы утилизации",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "elasticity-manager" },
                label: "Степень упругости",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              "Т",
              {
                to: { name: "containers-manager" },
                label: "Тары",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "hardness-manager" },
                label: "Твердость	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "thermal_stability-manager" },
                label: "Термостабильность (микроволновка)	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "heat_resistance-manager" },
                label: "Термоустойчивость (шарик)	",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
              {
                to: { name: "washing-types-manager" },
                label: "Типы моек",
                icon: "table-of-contents",
                permissions: ["admin"],
              },
            ],
          ],
        },
      ],
      "Аналитика",
      [
        {
          label: "Отчеты",
          icon: "table-of-contents",
          submenu: "reports",
          permissions: [
            "admin",
            "controller",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager",
          ],
          props: [
            [
              "Производство",
              {
                to: { name: "activity" },
                label: "Отчет по активности",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
              {
                to: { name: "export-to-crm" },
                label: "Отчет по выгрузке",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
              {
                to: { name: "deviant" },
                label: "Отчет по кол. отклонению",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
              {
                to: { name: "washings" },
                label: "Отчет по мойкам",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
              {
                to: { name: "result-pp" },
                label: "Отчет по результатам ПП",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
              {
                to: { name: "losses" },
                label: "Отчет по потерям АТОМ",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
              {
                to: { name: "laboratory" },
                label: "Отчет по лаборатории",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"],
              },
            ],
          ],
        },
      ],

      "Настройки",
      [
        {
          to: { name: "settings" },
          label: "Настройки",
          icon: "cog",
          // permissions: ['admin'],
        },
      ],
      "Информация",
      [
        {
          href: "https://wiki.rusbiomix.ru/",
          target: "_blank",
          label: "База знаний",
          icon: "wikipedia",
        },
      ],
    ];
    return _menu
      .map((item: any) => {
        const _type = typeof item;
        if ((_type as string) === "object") {
          item = item.map((child_item: any) => {
            if (child_item.permissions) {
              child_item =
                child_item.permissions
                  .filter((role: string) => this.actor.roles.includes(role))
                  .filter((i: any) => i).length > 0
                  ? child_item
                  : null;
              if (child_item && child_item.props) {
                child_item.props[0] = child_item.props[0]
                  .map((prop: any) => {
                    return !prop.permissions ||
                      prop.permissions
                        .filter((role: string) =>
                          this.actor.roles.includes(role)
                        )
                        .filter((i: any) => i).length > 0
                      ? prop
                      : null;
                  })
                  .filter((i: any) => {
                    return i;
                  });
              }
            }
            return child_item;
          });
          if (item.length == 0) {
            item = null;
          } else {
            item = item.filter((i: any) => {
              return i;
            });
          }
        }
        return item;
      })
      .filter((i: any) => {
        return i;
      });
  }

  created() {
    // noop
  }

  pipelines: any = [];

  mounted() {
    this.loadPipelines();

    this.$store.subscribe((mutation: any, state: any) => {
      switch (mutation.type) {
        case "ubic/SET_IDENTITY": {
          this.loadPipelines();
          break;
        }
      }
    });
  }

  loadPipelines() {
    if (!this.isAuthenticated) {
      return;
    }

    (this as any)
      .$db([
        (this as any)
          .$q("QNAME")
          .select()
          .fileds({
            id: `pipelines.id`,
            label: `pipelines.name`,
          })
          .from("pipelines")
          .limit(1000),
      ])
      .then((result: ServerResult) => {
        this.pipelines = result.getOperation("QNAME").getContent().documents;
      });
  }
}
